import React from 'react';
import { Opener } from './Opener';
import { ActionMenu } from './ActionMenu';
import { Icon } from './Icon';
import { PropTypes } from 'prop-types';

import styles from './actionButton/actionButton.module.scss';

export class ActionButton extends React.Component {
  render() {
    const {
      className = '',
      actions,
    } = this.props;

    return (
      <Opener
        className={`${styles.container} ${className}`}
        btn={<button className={styles.btn}>
          <Icon name="More" />
        </button>}
        content={<ActionMenu actions={actions} />}
        contentClassName={styles.content}
      />
    );
  }
};

ActionButton.propTypes = {
  className: PropTypes.string,
  actions: PropTypes.array,
};
